export const ValidationPatterns = {
  email:
    '^(([^<>()\\[\\]\\\\.,;:\\s@\\"/]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\\"/]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$', //NOSONAR
  phone: '^[\\d ()+-]+$',
  noPrecedingExclamationOrSpacesRegex: /^(?!!|\s)./,
  numbers: '[0-9]*'
};
